import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);
// import createPersistedState from 'vuex-persistedstate'
const modulesFiles = require.context('./modules', true, /\.js/);
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  // 获取文件名
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1');
  // 获取该路径下的文件内容
  const value = modulesFiles(modulePath);
  // 获取文件内default 默认返回对象
  modules[moduleName] = value.default;
  
  return modules;
}, {});
const store=new Vuex.Store({ 
    modules,
    // plugins:[
    // new    createPersistedState({
    //         storage:{
    //             getItem:(key)=>{
    //                uni.getStorageSync(key);
    //             },
    //             setItem:(key,value)=>{
    //                 let values=JSON.parse(value)
    //                 for(let keys in values)
    //                 uni.setStorageSync(keys,JSON.stringify(values[keys]) );
    //              },
    //              removeItem:(key)=>{
    //                  uni.removeStorageSync(key);
    //              }
    //         }
    //     })
    // ]
})
export default store
